var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"red",attrs:{"dark":_vm.AppisDarkMode,"flat":"","tile":""}},[(_vm.Ready)?_c('v-breadcrumbs',{class:_vm.AppisDarkModeCard,staticStyle:{"z-index":"3"},attrs:{"dark":_vm.AppisDarkMode,"items":_vm.items,"divider":"-"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }